import React from 'react'
import { Alert as ShadcnAlert, AlertDescription } from '@/components/ui/alert'
import { cn } from '@/lib/utils'

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: string
  isOpen?: boolean
  toggle?: () => void
}

const colorClassMap: Record<string, string> = {
  primary: 'border-primary text-primary',
  success: 'border-[hsl(var(--success))] text-[hsl(var(--success))]',
  danger: 'border-destructive text-destructive',
  warning: 'border-[hsl(var(--warning))] text-[hsl(var(--warning))]',
  info: 'border-[hsl(var(--info))] text-[hsl(var(--info))]',
}

export const Alert: React.FC<AlertProps> = ({
  color = 'primary',
  isOpen = true,
  className,
  children,
  ...props
}) => {
  if (!isOpen) return null

  return (
    <ShadcnAlert
      variant={color === 'danger' ? 'destructive' : 'default'}
      className={cn(colorClassMap[color], className)}
      {...props}
    >
      <AlertDescription>{children}</AlertDescription>
    </ShadcnAlert>
  )
}
